export const qnaKey = (resource, id, ...rest) => ['qna', resource, `${id}`, ...rest];

export const listParams = ({ page, pageSize, order }) => ({
  offset: (page - 1) * pageSize,
  limit: pageSize,
  order,
});
